import { Button, useActionsBtnContext, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { datetimeWithSecondsFormat } from 'constans/dateFormat';
import { format } from 'date-fns';
import _ from 'lodash';
import { LeadgenFilter as LeadgenFilterType } from 'models/api/leadgen';
import { Prop, PropValue } from 'models/api/prop';
import { ReportAdd } from 'models/api/report';
import Id from 'models/id';
import { useTranslation } from 'react-i18next';
import 'scss/Main.scss';

type LeadgenReportBtnProps = Id & {
    reportProps: Prop[];
    reportPropsFetching: boolean;
    addReportFn: (item: ReportAdd) => void;
};

type PropValueWithCode = {
    code: string;
    values: PropValue[] | null;
};

const getFilledProps = (props: Prop[], propValues: PropValueWithCode[]): Prop[] => {
    const res = _.clone(props);

    for (let i = 0; i < res.length; i++) {
        const prop = res[i];
        prop.selectOptions = null;

        const propValue = propValues.find((j) => j.code === prop.code);
        if (propValue) {
            prop.values = propValue.values;
        }
    }

    return res;
};

export default function LeadgenReportBtn({
    id,
    reportProps,
    reportPropsFetching,
    addReportFn,
}: LeadgenReportBtnProps) {
    const { t } = useTranslation();
    const { addRequest } = useActionsBtnContext();

    const { filter } = useGridFilterUrlContext<LeadgenFilterType>();

    return (
        <div>
            <Button
                isPending={reportPropsFetching}
                className="workplace-delete-btn popover-btn"
                type="button"
                onClick={() => {
                    if (!reportProps.length) {
                        return;
                    }
                    addRequest({
                        content: t('BackOfficeAreYouSure'),
                        confirmCallback: (res) => {
                            if (res && id !== undefined) {
                                const props = getFilledProps(reportProps, [
                                    {
                                        code: 'Sd',
                                        values: [
                                            {
                                                id: null,
                                                value: format(
                                                    filter.sd ? new Date(filter.sd) : new Date(),
                                                    datetimeWithSecondsFormat
                                                ),
                                            },
                                        ],
                                    },
                                    {
                                        code: 'Ed',
                                        values: [
                                            {
                                                id: null,
                                                value: format(
                                                    filter.ed ? new Date(filter.ed) : new Date(),
                                                    datetimeWithSecondsFormat
                                                ),
                                            },
                                        ],
                                    },
                                    {
                                        code: 'Leadgens',
                                        values: [{ id: null, value: id.toString() }],
                                    },
                                ]);

                                addReportFn({ type: 'Leadgens', props: props });
                            }
                        },
                    });
                }}
            >
                <FontAwesomeIcon
                    icon={faFileLines}
                    className="text-danger workplace-action-btn__icon"
                />
                <span>{t('BackOfficeLeadgenReport')}</span>
            </Button>
        </div>
    );
}
